module.exports = __webpack_public_path__ + "static/media/image3.1251366f.jpg";